<template>
  <div class="contact-us full-screen">
    <div class="wrapper wrapper-full-page section content">
      <div class="">
        <div class="container">
          <div class="row">
            <div class="col-md-12 col-md-offset-2 text-center">
              <h2 class="title text-danger text-center">404 Not Found</h2>
              <h2 class="title">
               Ndodhi nje gabim !! <br>
                <!-- <router-link :to="{ path: '/Dashboard' }">Ballina</router-link> -->
              </h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>
